import { tryLoadAndStartRecorder } from "@alwaysmeticulous/recorder-loader";

const METICULOUS_RECORDING_TOKEN = "lsFr24sbZuIEYhfCMAEhCXgSWj4H0zgaEtwAoDoz";

declare global {
  interface Window {
    __siteMonitoringMeticulousLoadPromise?: Promise<void>;
  }
}

const isProductionEnv = (envName: string) => {
  return envName === "prod" || envName === "production";
};

export const startMeticulousRecorder = async (envName: string) => {
  if (isProductionEnv(envName) || typeof window === "undefined") {
    return;
  }

  if (!window.__siteMonitoringMeticulousLoadPromise) {
    window.__siteMonitoringMeticulousLoadPromise = tryLoadAndStartRecorder({
      recordingToken: METICULOUS_RECORDING_TOKEN,
      isProduction: false,
      disableTrackerId: true,
      disableErrorReporting: true,
    }).then(() => undefined);
  }

  await window.__siteMonitoringMeticulousLoadPromise;
};
